<template>
  <div id="terminos-condiciones" class="p-2 mb-10" style="min-height: 720px;">
    <div class="text-right c-pointer mb-2" @click="$FModal.hide()">
      <i class="fa-solid fa-circle-xmark fa-2x fg-gray"></i>
    </div>
    <template v-if="cargando">
      <div class="d-flex flex-justify-center" style="margin-top: 50%">
        <div data-role="activity" data-type="simple" data-style="color"></div>
      </div>
      <div class="d-flex flex-justify-center text-medium">
        <span>Cargando...</span>
      </div>
    </template>
    <template v-else>
      <div id="contenido-g6ycNgas6cj6jspX" class="text-small" v-html="contenidoPersonalizado"></div>
    </template>
  </div>
</template>

<script>
export default {
  name: "terminos-condiciones",
  data() {
    return {
      documento: {},
      cargando: true
    }
  },
  props: {
    documentoId: {
      type: Number,
      default: null
    },
    documentoSlug: {
      type: String,
      default: null
    }
  },
  async mounted() {
    this.cargando = true
    await this.getData()
    this.cargando = false
  },
  methods: {
    async getData() {
      this.documento.content = "<div class='text-center text-secondary'>Error al mostrar documento</div>"
      const docId = this.documentoId !== null ? this.documentoId : this.documentoSlug

      await this.axios.get(
        `api/v2/help/${docId}`
      ).then(response => {
        if (response.status === 200) {
          this.documento = response.data
        }
      }).catch(error => console.log(error))
    }
  },
  computed: {
    contenidoPersonalizado() {
      return Object.keys(this.documento).length === 0 ? "" :
          this.documento.content.replace(/\[usuario\]/g, this.user_computed.informacion.nombre_completo)
    }
  }
}
</script>

<style>
/*No encuentro otra forma de que funcione, no puede ser scoped*/
#contenido-g6ycNgas6cj6jspX ol,#contenido-g6ycNgas6cj6jspX ul,#contenido-g6ycNgas6cj6jspX dl {
  list-style-position: unset;
}
#contenido-g6ycNgas6cj6jspX ol {
  list-style-type: decimal;
}
</style>